document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.custom-collection-tab');

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('.custom-collection-tab__tab');
    const panels = section.querySelectorAll('.custom-collection-tab__panel');

    if (!tabs.length || !panels.length) return;

    const activateTab = (tab) => {
      const targetId = tab.getAttribute('data-target');
      const targetPanel = section.querySelector(`#${CSS.escape(targetId)}`);

      if (!targetPanel) return;

      tabs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('tabindex', '-1');
      });

      panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      targetPanel.hidden = false;
      targetPanel.classList.add('is-active');
    };
 
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(tab);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight') {
          nextIndex = index + 1 >= tabs.length ? 0 : index + 1;
        }

        if (event.key === 'ArrowLeft') {
          nextIndex = index - 1 < 0 ? tabs.length - 1 : index - 1;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex === null) return;

        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.custom-collection-tab');

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('.custom-collection-tab__tab');
    const panels = section.querySelectorAll('.custom-collection-tab__panel');

    if (!tabs.length || !panels.length) return;

    const activateTab = (tab) => {
      const targetId = tab.getAttribute('data-target');
      const targetPanel = section.querySelector(`#${CSS.escape(targetId)}`);

      if (!targetPanel) return;

      tabs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('tabindex', '-1');
      });

      panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      targetPanel.hidden = false;
      targetPanel.classList.add('is-active');
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(tab);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight') {
          nextIndex = index + 1 >= tabs.length ? 0 : index + 1;
        }

        if (event.key === 'ArrowLeft') {
          nextIndex = index - 1 < 0 ? tabs.length - 1 : index - 1;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex === null) return;

        event.preventDefault();
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });

    section.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-load-more]');
      if (!button) return;

      event.preventDefault();

      const nextUrl = button.getAttribute('data-next-url');
      const currentPanel = button.closest('.custom-collection-tab__panel');
      const currentGrid = currentPanel.querySelector('[data-grid]');

      if (!nextUrl || !currentPanel || !currentGrid) return;

      button.disabled = true;
      button.textContent = 'Cargando...';

      try {
        const response = await fetch(nextUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) throw new Error('Load more request failed');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newPanel = doc.querySelector(`#${CSS.escape(currentPanel.id)}`);
        if (!newPanel) throw new Error('Panel not found in response');

        const newGrid = newPanel.querySelector('[data-grid]');
        const newButton = newPanel.querySelector('[data-load-more]');

        if (newGrid) {
          currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }

        if (newButton) {
          button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
          button.disabled = false;
          button.textContent = 'Ver más';
        } else {
          button.remove();
        }
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Ver más';
        console.error(error);
      }
    });
  });
});